import { Button, Form, Input, message } from 'antd'
import React, { useEffect, useRef, useState, useCallback } from 'react'
import styles from './form.module.scss'
import Code from './Code'
import axios from 'axios'
import { useMediaQuery } from 'react-responsive'
import OnlyNumber from '../../../helpers/OnlyNumbers'
import StringHelper from '../../../helpers/StringHelper'

// Initialize dataLayer at module level to guarantee availability
window.dataLayer = window.dataLayer || [];

const pushToDataLayer = (eventData) => {
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, 1500); // fallback if GTM is slow or absent
    window.dataLayer.push({
      ...eventData,
      eventCallback: () => {
        clearTimeout(timeout);
        resolve();
      },
      eventTimeout: 1500,
    });
  });
};

function RegisterForm() {
  const [form] = Form.useForm()
  const timeoutRef = useRef(null);
  const [mobileNumber, setMobileNumber] = useState()
  const [step, setStep] = useState(1)
  const [input, setInput] = useState({
    value: '',
    valid: []
  })
  const [otpLength, setOtpLength] = useState()
  const [seconds, setSeconds] = useState()
  const [loading, setLoading] = useState(false)
  const [securityData, setSecurityData] = useState()
  const [otpError, setOtpError] = useState('')
  const isMobile = useMediaQuery({ maxWidth: 921 })
  const [givenGift, setGivenGift] = useState(false)
  const [jwtString, setJwtString] = useState()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const store = localStorage.getItem('app-store')
      if (store) {
        const storeObj = JSON.parse(store)
        if (
          storeObj.state?.auth?.userToken
        ) {
          setMobileNumber(storeObj?.state?.auth?.mobile)
          setStep(3)
        }
      }
    }
  }, [])

  useEffect(() => {
    if (seconds > 0) {
      timeoutRef.current = setTimeout(() => setSeconds(seconds - 1), 1000)
    }

    return () => clearTimeout(timeoutRef?.current);
  }, [seconds])

  useEffect(() => {
    if (input.value?.length === Number(otpLength)) {
      form.submit()
    }
  }, [input.value])


  const logUserSignUp = (registered, mobile) => {
    if (registered) {
      return pushToDataLayer({
        'event': 'sign_up',
        'method': 'otp'
      });
    } else {
      return pushToDataLayer({
        'event': 'registration',
        'authentication_method': 'mobile_number',
        'user_id': mobileNumber || mobile
      });
    }
  }

  const logNewUserSubmission = () => {
    return pushToDataLayer({
      "event": "football_registration",
    });
  };

  const redirectToHome = () => {
    window.location.replace(window.location.origin)
  }

  const sendSubmitAPI = (userToken, isReturningUser = false) => {
    setGivenGift(true)
    const local = JSON.parse(localStorage?.getItem('app-store'));

    axios
      .post(
        'https://coreapi.bimeh.com/v1/landing/enjoy-football/submit',
        {
          MobileNumber: mobileNumber,
          SecurityData: securityData,
        },
        {
          headers: {
            "Authorization": `Bearer ${userToken ? userToken : jwtString ? jwtString : local?.state?.auth?.userToken}`,
            Token: 'da4aa2f8-70d9-4d56-b577-3162dfae2c0f',
          }
        }
      )
      .then(async () => {
        // For returning users who skipped login, log a sign_up event
        if (isReturningUser) {
          await logUserSignUp(true);
        }
        await logNewUserSubmission()
        setGivenGift(true)
        message.success('شما هدیه را دریافت کردید')
        setTimeout(redirectToHome, 3000)
        setInput({
          value: '',
          valid: []
        })
      })
      .catch(async (err) => {
        message.error(err?.response?.data?.Message || 'خطا در ارتباط با سرور')
        setOtpError(err?.response?.data?.Message || 'خطا در ارتباط با سرور')
        setTimeout(redirectToHome, 3000)
      })
      .finally(() => setLoading(false))
  }

  const onFinish = values => {
    if (step === 1 && !StringHelper.isMobile(values?.username)) {
      return
    }
    setLoading(true)
    if (step === 1) {
      setMobileNumber(values.username)

      axios
        .post(
          'https://coreapi.bimeh.com/v1/landing/enjoy-football/authentication',
          {
            MobileNumber: values.username
          },
          {
            headers: {
              Token: 'da4aa2f8-70d9-4d56-b577-3162dfae2c0f'
            }
          }
        )
        .then(res => {
          const data = res.data
          setOtpLength(data?.OtpLength)
          setSeconds(data?.ResendWaitSeconds)
          setSecurityData(data?.SecurityData)
          setStep(2)
        })
        .catch(err => {
          message.error(err?.response?.data?.Message || 'خطا در ارتباط با سرور')
        })
        .finally(() => setLoading(false))
    } else if (step === 2) {
      axios
        .post(
          'https://coreapi.bimeh.com/v1/landing/enjoy-football/login',
          {
            Code: input.value,
            SecurityData: securityData,
            queryParam: ''
          },
          {
            headers: {
              Token: 'da4aa2f8-70d9-4d56-b577-3162dfae2c0f',
            }
          }
        )
        .then(async (resp) => {
          await logUserSignUp(resp.data.Registered, mobileNumber)
          setStep(3)
          setInput({
            value: '',
            valid: []
          })
          let local

          if (JSON.parse(localStorage?.getItem('app-store'))) {
            local = JSON.parse(localStorage?.getItem('app-store'))
            if (!local?.state?.auth?.userToken) {
              local = {
                state: {
                  auth: {
                    mobile: '',
                    userToken: ''
                  },
                  user: {
                    info: {
                      data: {
                        UserName: ''
                      }
                    }
                  },
                  business: local?.state?.business

                }
              }
            }
          } else {
            local = {
              state: {
                auth: {
                  mobile: '',
                  userToken: ''
                },
                user: {
                  info: {
                    data: {
                      UserName: ''
                    }
                  }
                },
                business: {
                  isBimeh: true
                }
              }
            }
          }
          local.state.auth.mobile = mobileNumber
          local.state.auth.userToken = resp?.data?.JWT
          setJwtString(resp.data.JWT)
          local.state.user.info.data.UserName = mobileNumber
          localStorage.setItem('app-store', JSON.stringify(local))
          if (resp) {
            sendSubmitAPI(resp?.data?.JWT, false)
          }
        })
        .catch(err => {
          setOtpError(err?.response?.data?.Message || 'خطا در ارتباط با سرور')
        })
        .finally(() => setLoading(false))
    } else if (step === 3) {
      sendSubmitAPI(jwtString, true)
      return
    }
  }

  const onFinishFailed = errorInfo => { }

  const retryFunc = () => {
    setLoading(true)
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setSeconds(null);
    axios
      .post(
        'https://coreapi.bimeh.com/v1/landing/enjoy-football/authentication',
        {
          MobileNumber: mobileNumber
        },
        {
          headers: {
            Token: 'da4aa2f8-70d9-4d56-b577-3162dfae2c0f'
          }
        }
      )
      .then(res => {
        const data = res.data
        if (data?.Registered) {
          message.error('شما قبلا در بیمه دات‌کام ثبت نام کرده اید')
        } else {
          setOtpLength(data?.OtpLength)
          setSeconds(data?.ResendWaitSeconds)
          setSecurityData(data?.SecurityData)
          setStep(2)
        }
      })
      .catch(err => {
        message.error(err?.response?.data?.Message || 'خطا در ارتباط با سرور')
      })
      .finally(() => setLoading(false))
  }

  return (
    <Form
      className={styles.form}
      name='login'
      layout='vertical'
      colon={false}
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      initialValues={{ username: mobileNumber }}
      style={isMobile ?
        step === 1 ? { minHeight: '380px' } :
          step === 3 ? { minHeight: '200px' } :
            step === 2 ? { minHeight: '347px' } :
              {} :
        step === 1 ? { minHeight: '390px', minWidth: "460px" } :
          step === 2 ? { minHeight: '390px' } : step === 3 ? { minHeight: '200px' } : {}}
    >
      {
        step === 1 ?
          <p>
            برای دریافت هدیه ۴۰۰,۰۰۰ تومانی شماره تو وارد کن.
          </p>
          : null
      }
      {step === 1 ? (
        <Form.Item
          className={styles.mobileField}
          label={<div className={styles.mobileFieldLabel}>شماره موبایل</div>}
          name='username'
          rules={[
            { required: true, message: 'تلفن همراه خود را وارد نمایید', validateTrigger: 'onSubmit' },
            {
              validateTrigger: 'onSubmit',
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve()
                }
                if (StringHelper.isMobile(value)) {
                  return Promise.resolve()
                }
                if (value.length < 11) {
                  return Promise.reject('شماره موبایل باید ۱۱ رقم باشد')
                }
                return Promise.reject('شماره موبایل وارد شده صحیح نیست')
              }
            }
          ]}
          normalize={value =>
            StringHelper.getEnglishNum(value || '').replace(/\D/g, '').slice(0, 11)
          }
          style={(isMobile && step === 1) ? { marginTop: '-96px' } : {}}
        >
          <Input
            className=''
            placeholder='09*********'
            type='tel'
            onKeyPress={OnlyNumber}
            onKeyDown={e => {
              if (e.key === 'Enter' && StringHelper.isMobile(form.getFieldValue('username')) && !loading) {
                e.preventDefault()
                form.submit()
              }
            }}
            maxLength={11}
            id='login-input'
            data-tracking-id='login-input'
          />
        </Form.Item>
      ) : step === 2 ? (
        <Form.Item name='code'>
          <div className={styles.headerStepTwo}>
            <h2 className={styles.headerStepTwoTitle}>کد تایید را وارد کنید</h2>
            <p className={styles.hintP}>
              کد ارسال شده به شماره {mobileNumber} را وارد کنید
            </p>
            <span className={styles.back} onClick={() => setStep(1)}>
              اصلاح شماره موبایل
            </span>
          </div>
          <Code
            otpError={otpError}
            value={input.value}
            resetErrorMessage={() => { }}
            onChange={(value, name, valid) => {
              setInput({ ...input, value, valid })
            }}
            split={Array.from({ length: otpLength }, x => 1)}
          />
          <div className={`${styles.timer} surface-color`} id='timer'>
            <span>
              <span>{StringHelper.formatCountdown(seconds)} </span>
              <span style={{ color: 'var(--Surface-600, #696969)' }}>
                ثانیه تا ارسال مجدد کد
              </span>
            </span>
            <Button
              className={`${seconds > 0 ? styles.retryBtnWaiting : styles.retryBtn} rb`}
              onClick={retryFunc}
              disabled={seconds > 0 || loading}
              loading={loading}
              style={
                seconds > 0 ? { backgroundColor: '#EFEFEF', color: '#ababab' } : {}
              }
            >
              ارسال مجدد کد
            </Button>
          </div>
        </Form.Item>
      ) :
        step === 3 ?
          (
            <Form.Item name='submit'>
              <p>
                برای دریافت اعتبار <span>۴۰۰ هزار تومنی</span>، بر روی دکمه زیر کلیک کنید.
              </p>
            </Form.Item>
          )
          : null}
      <Button
        disabled={givenGift || (step === 2 && input.value.length !== otpLength)}
        loading={loading}
        type='primary'
        htmlType='submit'
        className={styles.submitBtn}
        data-tracking-id='lezatfb-submit-btn'
      >
        {step === 1 ? 'تایید و ادامه' : step === 3 ? 'دریافت اعتبار ۴۰۰ هزار تومنی ' : 'ثبت نام'}
      </Button>
    </Form>
  )
}
export default RegisterForm
